import {createStyles, Textarea} from '@mantine/core';
import React, {useState} from 'react';

import {trackEvent} from 'analytics/Analytics';
import {LLM_CHAT_ANALYTICS_ACTIONS} from 'constants/analytics-products/LLMChatConstants';

export interface UserAgentGuidelinesProps {
  value: string;
  onSave: (newValue: string) => Promise<void>;
}

const PLACEHOLDER = 'Description of your response preferences or specific instructions to keep in mind.';

const useStyles = createStyles(() => ({
  input: {
    resize: 'vertical',
  },
}));

export default function UserAgentGuidelines({value, onSave}: UserAgentGuidelinesProps): JSX.Element {
  const {classes} = useStyles();
  const [tempValue, setTempValue] = useState<string>(value);

  const handleSaveValue = async (newValue: string): Promise<void> => {
    await onSave(newValue);
    trackEvent(LLM_CHAT_ANALYTICS_ACTIONS.SAVED_RESPONSE_PREFERENCES, {
      character_count: newValue.length,
    });
  };

  return (
    <Textarea
      w="100%"
      minRows={2}
      value={tempValue}
      onChange={(e) => {
        setTempValue(e.currentTarget.value);
      }}
      onBlur={() => {
        if (tempValue !== value) {
          handleSaveValue(tempValue);
        }
      }}
      placeholder={PLACEHOLDER}
      classNames={{input: classes.input}}
    />
  );
}
